import { Rating as MuiRating } from "@mui/material";
import { FieldValues, useController } from "react-hook-form";
import { RatingContentProps } from "../lib/type";
import { IconContainer } from "./IconContainer";

export const Rating = <T extends FieldValues>({
    control,
    name,
    defaultValue,
    ...rest
}: RatingContentProps<T>) => {
    const {
        field: { onChange, ...fieldData },
    } = useController({ control, name, defaultValue });

    return (
        <MuiRating
            {...fieldData}
            onChange={(_, value) => {
                onChange(value);
            }}
            className={"gap-5 flex-center-row max-sm:gap-2"}
            precision={1}
            IconContainerComponent={IconContainer}
            {...rest}
        />
    );
};
